/* OSSIGENO theme behaviour: menu, cookie panel, bag, product gallery, quantity, modes, product finder. */
(function () {
  'use strict';
  var $ = function (sel, root) { return (root || document).querySelector(sel); };
  var $$ = function (sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); };
  var ICON_CHECK = '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-label="Selected"><path d="M20 6 9 17l-5-5"></path></svg>';

  /* Mobile menu */
  var toggle = $('[data-menu-toggle]');
  var menu = $('#mobile-menu');
  function setMenu(open) {
    if (!toggle || !menu) return;
    menu.hidden = !open;
    toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    toggle.setAttribute('aria-label', open ? 'Close navigation menu' : 'Open navigation menu');
    $('[data-menu-open]', toggle).hidden = open;
    $('[data-menu-close]', toggle).hidden = !open;
  }
  if (toggle) {
    toggle.addEventListener('click', function () { setMenu(menu.hidden); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') setMenu(false); });
  }

  /* Cookie panel */
  var cookie = $('.cookie-panel');
  if (cookie) {
    var choice = null;
    try { choice = localStorage.getItem('ossigeno-cookie-choice'); } catch (e) {}
    if (!choice) cookie.hidden = false;
    $$('[data-cookie-choice]', cookie).forEach(function (b) {
      b.addEventListener('click', function () {
        try { localStorage.setItem('ossigeno-cookie-choice', b.getAttribute('data-cookie-choice')); } catch (e) {}
        cookie.hidden = true;
      });
    });
  }

  /* Toast */
  var toastEl = $('.o-toast');
  var toastTimer;
  function toast(msg, link) {
    if (!toastEl) return;
    toastEl.innerHTML = '';
    var span = document.createElement('span');
    span.textContent = msg;
    toastEl.appendChild(span);
    if (link) {
      var a = document.createElement('a');
      a.href = link.href; a.textContent = link.text; a.className = 'inline-link';
      toastEl.appendChild(a);
    }
    toastEl.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.hidden = true; }, 4500);
  }

  /* Bag count */
  function setBagCount(n) {
    $$('[data-bag-count]').forEach(function (el) { el.textContent = n; el.hidden = n < 1; });
    $$('[data-bag-count-text]').forEach(function (el) { el.textContent = n; });
    var link = $('[data-bag-link]');
    if (link) link.setAttribute('aria-label', 'Shopping bag, ' + n + ' items');
  }

  /* Add to bag (AJAX with normal form fallback) */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches || !form.matches('[data-add-form]')) return;
    if (!window.fetch) return;
    e.preventDefault();
    var btn = $('button[type=submit]', form);
    var label = btn ? btn.innerHTML : '';
    if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json' },
      body: new FormData(form)
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.d.description || res.d.message || 'This item could not be added.');
        return fetch(root + 'cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        setBagCount(cart.item_count);
        toast('Added to your bag.', { href: root + 'cart', text: 'View bag' });
      })
      .catch(function (err) { toast(err.message || 'This item could not be added.'); })
      .then(function () { if (btn) { btn.disabled = false; btn.innerHTML = label; } });
  });

  /* Quantity steppers */
  $$('[data-qty]').forEach(function (q) {
    var input = $('input', q);
    function step(d) {
      var v = parseInt(input.value, 10) || 1;
      input.value = Math.min(99, Math.max(1, v + d));
    }
    $('[data-qty-minus]', q).addEventListener('click', function () { step(-1); });
    $('[data-qty-plus]', q).addEventListener('click', function () { step(1); });
  });

  /* Variant select updates price */
  var vs = $('.variant-select');
  if (vs) vs.addEventListener('change', function () {
    var opt = vs.options[vs.selectedIndex];
    var price = $('[data-price]');
    if (price && opt) price.textContent = opt.textContent.split('—').pop().trim();
  });

  /* Product gallery: swipeable track with smooth snapping */
  var gallery = $('[data-gallery]');
  if (gallery) {
    var track = $('[data-gallery-track]', gallery);
    var slides = track ? $$('[data-gallery-img]', track) : [];
    var thumbs = $$('[data-gallery-thumb]', gallery);
    var count = $('[data-gallery-count]', gallery);
    var idx = 0;
    function mark(i) {
      idx = i;
      thumbs.forEach(function (t, n) { t.setAttribute('aria-pressed', n === idx ? 'true' : 'false'); });
      if (count) count.textContent = (idx + 1) + ' / ' + slides.length;
      var t = thumbs[idx];
      if (t && t.parentNode) {
        var p = t.parentNode, l = t.offsetLeft - p.offsetLeft;
        if (l < p.scrollLeft || l + t.offsetWidth > p.scrollLeft + p.clientWidth) p.scrollTo({ left: l - 8, behavior: 'smooth' });
      }
    }
    function show(i) {
      if (!track || !slides.length) return;
      i = (i + slides.length) % slides.length;
      track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' });
      mark(i);
    }
    if (track) {
      var ticking = false;
      track.addEventListener('scroll', function () {
        if (ticking) return; ticking = true;
        requestAnimationFrame(function () {
          ticking = false;
          var i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
          if (i !== idx && i >= 0 && i < slides.length) mark(i);
        });
      }, { passive: true });
      window.addEventListener('resize', function () { track.scrollLeft = idx * track.clientWidth; });
    }
    thumbs.forEach(function (t, n) { t.addEventListener('click', function () { show(n); }); });
    var prev = $('[data-gallery-prev]', gallery), next = $('[data-gallery-next]', gallery);
    if (prev) prev.addEventListener('click', function () { show(idx - 1); });
    if (next) next.addEventListener('click', function () { show(idx + 1); });

    var zoom = $('[data-zoom]');
    var enlarge = $('[data-gallery-enlarge]', gallery);
    if (zoom && enlarge && slides.length) {
      var closeZoom = function () { zoom.hidden = true; };
      enlarge.addEventListener('click', function () {
        var img = slides[idx];
        $('[data-zoom-img]', zoom).src = img.currentSrc || img.src;
        zoom.hidden = false;
        $('[data-zoom-close]', zoom).focus();
      });
      zoom.addEventListener('click', closeZoom);
      $('.zoom-frame', zoom).addEventListener('click', function (e) { e.stopPropagation(); });
      $('[data-zoom-close]', zoom).addEventListener('click', closeZoom);
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeZoom(); });
    }
  }

  /* AuraGlacier mode selector */
  var modes = $('[data-modes]');
  if (modes) {
    var nameEl = $('[data-mode-name]', modes);
    var headEl = $('[data-mode-head]', modes);
    $$('[data-mode]', modes).forEach(function (b, _, all) {
      b.addEventListener('click', function () {
        all.forEach(function (o) { o.setAttribute('aria-pressed', o === b ? 'true' : 'false'); });
        if (nameEl) nameEl.textContent = b.getAttribute('data-mode');
        if (headEl) headEl.textContent = b.getAttribute('data-head');
      });
    });
  }

  /* Product finder */
  var finder = $('[data-finder]');
  if (finder) {
    var QUESTIONS = [
      { q: 'What brought you here today?', a: ['One area needs extra attention.', 'My eyes look tired.', 'I want more ways to care for my skin.', "I'm exploring beauty technology."] },
      { q: 'Where would you like to focus?', a: ['A targeted area.', 'Under and around my eyes.', 'My face and wider beauty routine.', 'A little bit of everything.'] },
      { q: 'What matters most to you?', a: ['Targeted care.', 'Looking more rested.', 'Having different modes and options.', 'Keeping my routine simple.'] },
      { q: 'What kind of routine suits you?', a: ['A short, targeted session.', 'A simple eye-care ritual.', 'A multi-mode routine.', 'Whatever fits into my day.'] },
      { q: 'Which sounds most like you?', a: ['“I need something for this one thing.”', '“I want my eyes to look less tired.”', '“I like having options.”', '“I want beauty technology without fuss.”'] }
    ];
    var intro = $('[data-finder-intro]', finder);
    var quiz = $('[data-finder-quiz]', finder);
    var result = $('[data-finder-result]', finder);
    var mixed = $('[data-finder-mixed]', finder);
    var step = 0, answers = [];

    function panels(which) {
      intro.hidden = which !== 'intro';
      quiz.hidden = which !== 'quiz';
      result.hidden = which !== 'result';
      mixed.hidden = which !== 'mixed';
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
    function renderQ() {
      var Q = QUESTIONS[step];
      $('[data-q-step]', quiz).textContent = 'Question ' + (step + 1) + ' of ' + QUESTIONS.length;
      $('[data-q-bar]', quiz).style.width = ((step + 1) / QUESTIONS.length * 100) + '%';
      $('.quiz-progress', quiz).setAttribute('aria-valuenow', step + 1);
      $('[data-q-text]', quiz).textContent = Q.q;
      var list = $('[data-q-answers]', quiz);
      list.innerHTML = '';
      Q.a.forEach(function (text, i) {
        var b = document.createElement('button');
        b.type = 'button'; b.className = 'answer';
        b.setAttribute('aria-pressed', answers[step] === i ? 'true' : 'false');
        b.innerHTML = '<span class="answer-key">' + String.fromCharCode(65 + i) + '</span><span></span>' + (answers[step] === i ? ICON_CHECK : '');
        b.children[1].textContent = text;
        b.addEventListener('click', function () { answers[step] = i; renderQ(); });
        list.appendChild(b);
      });
      $('[data-q-back]', quiz).disabled = step === 0;
      $('[data-q-next]', quiz).disabled = answers[step] === undefined;
      $('[data-q-next-label]', quiz).textContent = step === QUESTIONS.length - 1 ? 'See my result' : 'Next';
    }
    function finish() {
      var t = [0, 0, 0];
      answers.forEach(function (a) { if (a < 3) t[a] += 1; });
      var order = [0, 1, 2].sort(function (x, y) { return t[y] - t[x]; });
      var clear = t[order[0]] > 0 && t[order[0]] > t[order[1]];
      if (clear) {
        $$('[data-result]', result).forEach(function (el) { el.hidden = +el.getAttribute('data-result') !== order[0]; });
        $$('[data-secondary]', result).forEach(function (el) { el.hidden = true; el.dataset.which = order[1]; });
        result.dataset.second = order[1];
        $('[data-q-another]', result).textContent = 'See another option';
        panels('result');
      } else {
        var any = t.some(function (n) { return n > 0; });
        var top = t[order[0]];
        var tied = [0, 1, 2].filter(function (i) { return any && t[i] === top; });
        $$('[data-mixed]', mixed).forEach(function (el) {
          var i = +el.getAttribute('data-mixed');
          el.style.display = (!any || t[i] === top) ? 'contents' : 'none';
        });
        /* More than one need: suggest the gift set that covers them.
           0+1 -> Glow (LiteButton + LumiWink), 1+2 -> Lumiere (AuraGlacier + LumiWink),
           anything else (0+2, all three, or no clear lean) -> Aurora (all three). */
        var key = tied.join('');
        var set = key === '01' ? 'glow' : key === '12' ? 'lumiere' : 'aurora';
        var shown = false;
        $$('[data-set]', mixed).forEach(function (el) {
          var on = el.getAttribute('data-set') === set;
          el.hidden = !on; if (on) shown = true;
        });
        var setWrap = $('[data-set-wrap]', mixed);
        if (setWrap) setWrap.hidden = !shown;
        panels('mixed');
      }
    }
    $('[data-finder-start]', finder).addEventListener('click', function () { step = 0; answers = []; renderQ(); panels('quiz'); });
    $('[data-q-back]', quiz).addEventListener('click', function () { if (step > 0) { step--; renderQ(); } });
    $('[data-q-next]', quiz).addEventListener('click', function () {
      if (answers[step] === undefined) return;
      if (step === QUESTIONS.length - 1) finish(); else { step++; renderQ(); }
    });
    $$('[data-q-retake]', finder).forEach(function (b) { b.addEventListener('click', function () { step = 0; renderQ(); panels('quiz'); }); });
    var another = $('[data-q-another]', result);
    another.addEventListener('click', function () {
      var el = $('[data-secondary="' + result.dataset.second + '"]', result);
      if (!el) return;
      el.hidden = !el.hidden;
      another.textContent = el.hidden ? 'See another option' : 'Hide another option';
    });
  }
})();
